import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Container maxWidth="sm" disableGutters>
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          The page you were looking for doesn't exist.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Back to Connections
        </Button>
      </Box>
    </Container>
  );
}
